import { Booking } from '../../types/booking';

// Importing Booking related action types.
import { BookingActionTypes } from '../actions/bookingActions';

// Defining the shape of the state for bookings.
interface BookingState {
    getBookings: Booking[];
}

// The initial state of the booking feature.
const initialState: BookingState = {
    getBookings: [],
};

// Reducer function for handling booking-related actions.
const bookingReducer = (
  state = initialState,
  action: BookingActionTypes
): BookingState => { 
  switch (action.type) {
    case 'ADD_BOOKING':
    if(Object.keys(state).length){
      const bookingsToAdd = Array.isArray(action.payload) ? action.payload : [action.payload];
      let updatedBookings = [...state.getBookings]; // Clone the existing array

      // Looping through each booking to add or update.
      for (const newBooking of bookingsToAdd) {
        const existingIndex = updatedBookings.findIndex((booking: Booking) => booking.id === newBooking.id);

        // Replace existing or add new booking.
        if (existingIndex !== -1) {
          updatedBookings[existingIndex] = newBooking;
        } else {
          updatedBookings.push(newBooking);
        }
      }
      
      return {
        ...state,
        getBookings: updatedBookings,
      };}
      else{
        return {getBookings:[]}
      }
    case 'UPDATE_BOOKING':
      // Update a specific booking based on the payload.
      return {
        ...state,
        getBookings: state.getBookings.map(booking =>
          booking.id === action.payload.id ? action.payload : booking
        ),
      };
      
    case 'DELETE_BOOKING':
      // Remove a booking from the state based on the payload.
      return {
        ...state,
        getBookings: state.getBookings.filter(booking => booking.id+"" !== action.payload),
      };
      
    default:
      // Return the current state if no actions match.
      return state;
  }
};

// Exporting the booking reducer.
export default bookingReducer;